<template>
  <div>
    <b-row>
      <b-col sm="6">
        <b-form-group
          label-for="statutActuel"
          :label-cols="3"
          :horizontal="true">
          <template slot="label"><b>Passer au statut</b></template>
          <b-form-select id="statutActuel"
                         :plain="true"
                         :options="attachedStatus"
                         v-model="myData.statutActuel"
                         :disabled="isDisabled('status')"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <span class="field-error">{{ errors.clotureDeces }}</span>
      </b-col>
    </b-row>
    <b-row v-if="showStatusMainTreatment">
      <b-col sm="6">
        <b-form-group
          label-for="statusMainTreatment"
          :label-cols="3"
          :horizontal="true">
          <template slot="label"><b>Passer le traitement principal au statut</b></template>
          <b-form-select id="statusMainTreatment"
                         :plain="true"
                         :options="mainTreatmentStatusOptions"
                         v-model="myData.statusMainTreatment"
                         :class="{hasError: errors.gestionnaire !== ''}"
          >
          </b-form-select>
          <span class="field-error d-block mr-1 ">{{ errors.mainTreatmentStatus }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-form-group
          label-for="collaborateurAffecte1"
          :label-cols="3"
          :horizontal="true">
          <template slot="label"><b>Collaborateur affecté</b></template>
          <b-form-input id="collaborateurAffecte1" type="text" v-model="myData.collaborateurAffecte" disabled>
          </b-form-input>
          <span v-if="myData.gestionnaireStructure"><b>Structure :</b> {{ myData.gestionnaireStructure }}</span>
          <span v-if="myData.gestionnaireEquipe"><br><b>Equipe : </b><span v-html="myData.gestionnaireEquipe"></span></span>
        </b-form-group>
      </b-col>
      <b-col sm="6" v-if="$parent.currentTreatment.type === 'Principal' && $parent.currentTreatment.categorie === 'Production'">
        <span><b>Collaborateur affectant : </b></span>
        <span>{{collaborateurAffectant}}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <span><b>date et heure de l'affectation : </b></span>
        <span>{{dateTimeAffectation}}</span>
      </b-col>
      <b-col sm="6" v-if="$parent.currentTreatment.id !== traitementControleId">
        <b-button v-if="canAffecte('autoAffecte')" type="button" @click="launchAffectation('autoAffecte')" title="S'Auto-Affecter le dossier pour traitement" class="ml-1 mr-1" size="md" variant="success">
          <i class="fa fa-arrow-right"></i><i class="fa fa-user"></i> Auto-Affecter
        </b-button>
        <b-button v-if="canAffecte('affecte')" type="button" @click="launchAffectation('affecte')" title="Affecter le dossier pour traitement" class="ml-1 mr-1" size="md" variant="primary">
          <i class="fa fa-arrow-right"></i><i class="fa fa-user-o"></i> Affecter
        </b-button>
        <b-button v-if="canAffecte('affecte')" type="button" @click="desaffectation()" title="Désaffecter le dossier pour traitement" class="ml-1 mr-1"
                  size="md" variant="warning">
          <i class="fa fa-eraser"></i> Désaffecter
        </b-button>
        <b-button v-if="isTempo()" type="button" @click="retourATraiter()" title="Remet le dossier en A affecter/A traiter" class="ml-1 mr-1"
                  size="md" variant="warning">
          <i class="fa fa-history"></i> Sortir de Tempo
        </b-button>
      </b-col>
    </b-row>

    <b-modal centered id="modal-affectation" ref="modal-affectation" title="Affectation du dossier à un gestionnaire">
      <auto-select
        v-model="gestionnaireGestion"
        :items="gestionnairesGestion"
        :loading="loadingGestionnaire"
        item-value="id"
        item-text="nom"
        menuDefaultPosition="top"
        :placeholder="gestionnaireGestion ? '' : 'Entrer le nom du gestionnaire'"
        disable-filtering-by-search
        @search="onSearchGestionnaireGestion"
        style="display: inline-block;"
        class="col-md-12"
        :class="{hasError: errors.gestionnaire !== ''}"
      >
        <template #no-data>
          {{ noData ? "Aucun gestionnaire trouvé." : "Il faut au moins 2 caractères pour la recherche." }}
        </template>
        <template slot="item" slot-scope="{ item: gest }">
          <div style="display: flex; align-items: center;">
            <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
          </div>
        </template>
        <template slot="selection" slot-scope="{ item: gest }">
          <div style="display: flex; align-items: center;">
            <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
          </div>
        </template>
        <template v-if="loadingGestionnaire" #input-end>
          <!-- <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator"> -->
          <i class="fa fa-spinner fa-pulse fa-fw"></i>
        </template>
      </auto-select>
      <span class="field-error d-block mr-1 ">{{ errors.gestionnaire }}</span>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModalAffectation()">Annuler</button>
          <button type="button" @click="hasManageDossier" class="btn btn-primary"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {isEmpty} from "@/utils/fileHelper";
  import {getUser} from "@/utils/auth";
  import {hasRule, espaceGestionRules as rules} from "@/utils/rulesHelper";
  import {CoolSelect as AutoSelect} from 'vue-cool-select';
  import { formatDateTime, dossierHasOpenIncident } from "@/utils/communHelper";
  import {isResponsable as isResponsableEquipe, getUserTraitementIds} from '@/utils/userHelper';

  export default {
    name: "SuiviDossier",
    props: [
      'dossier',
      'traitements'
    ],
    components: {
      AutoSelect,
    },
    data() {
      return {
        myData: {
          statutActuel: null,
          statusMainTreatment: null,
          collaborateurAffecte: '',
          gestionnaireStructure: '',
          gestionnaireProfil: '',
          gestionnaireEquipe: ''
        },
        dateTimeAffectation: '',
        collaborateurAffectant: '',
        gestionnaireAffecte: '',
        traitementId: '',
        attachedStatus: [],
        mainTreatmentStatusOptions: [],
        gestionnaireGestion: '',
        gestionnairesGestion: [],
        loadingGestionnaire: false,
        timeoutId: null,
        noData: false,
        errors: {gestionnaire: '', mainTreatmentStatus: '', clotureDeces: ''},
        showStatusMainTreatment: false,
        traitementControleId: false,
      }
    },
    watch: {
      dossier() {
        this.myData.statutActuel = null
        this.myData.statusMainTreatment = null
        this.getGestionnaireAffecte();
        this.getTreatmentStatus();
      },
      traitements() {
        this.getTreatmentStatus();
      },
      myData: {
        // handler: _.debounce(function(value) {
        //   this.$event.emit('editDossier', 'SuiviDossier',value);
        // },500),
        handler(value) {
          // console.log('isEmpty(value.statutActuel)',isEmpty(value.statutActuel))
          if (!isEmpty(value.statutActuel)) {
            this.manageChangeStatus();
          }
          this.$event.emit('editDossier', 'SuiviDossier',value);
        },
        deep: true,
      },
      gestionnaireAffecte() {
        // console.log('dans watcher : ', this.gestionnaireAffecte)
        if (this.gestionnaireAffecte !== undefined) {
          this.getCollaborateurAffectant()
        }
      }
    },
    created() {
      this.getTreatmentStatus();
      this.$event.on('saveError', (errors) => {
        this.errors.mainTreatmentStatus = errors.mainTreatmentStatus;
        this.errors.clotureDeces = errors.clotureDeces;
      })
    },
    async mounted() {
      this.getTraitementControle();
      this.getGestionnaireAffecte();
    },
    methods: {
      isDisabled(field) {
        return this.$parent.isDisabled(field)
      },
      getControles() {
        let self = this
        return new Promise(resolve => {
          this.$axios
            .get("/espaceQualite/controles/dossierId/" + this.dossier.id)
            .then(response => {
              resolve(response.data.controles)
            })
            .catch((error) => {
              // self.$store.commit('IS_LOADING', false)
                let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
                self.$swal({
                position: 'top',
                type:'error',
                title:'Attention !!',
                text:errorText,
                showConfirmButton: false,
                timer: 5000
              })
            })
        })
      },
      async getGestionnaireAffecte() {
        let resControles = await this.getControles();
        let gestionnaire = {}
        let controleDossier = []

        for (let i = 0; i < resControles.length; i++) {
          if (resControles[i].campagne_id === parseInt(this.$route.query.campagneId)) {
            controleDossier = resControles[i]
          }
        }
        if (controleDossier.campagne && controleDossier.campagne.traitement_id === parseInt(this.$route.query.traitementId)) {
          gestionnaire = controleDossier.gestionnaire_qualite
        }
        else {
          gestionnaire = _.head(this.dossier.gestionnaires.filter(gestionnaire => {
            return parseInt(gestionnaire.pivot.traitement_id) === parseInt(this.$route.query.traitementId)
          }))
        }
        // console.log('gestionnaire',gestionnaire)
        this.myData.gestionnaireProfil = !isEmpty(gestionnaire) && !isEmpty(gestionnaire.profil_active) ? gestionnaire.profil_active[0].libelle_affichage : '';
        this.myData.collaborateurAffecte = gestionnaire ? gestionnaire.nom + ' ' + gestionnaire.prenom + ' - (' + this.myData.gestionnaireProfil + ') ' : '';
        this.gestionnaireAffecte = gestionnaire
        this.myData.gestionnaireStructure = !isEmpty(gestionnaire) ? gestionnaire.structure.libelle : ''

        let gestionnaireResponsable = []
        if (!isEmpty(gestionnaire)) {
          gestionnaireResponsable = _.head(gestionnaire.equipes.filter(equipe => {
            return equipe.pivot.role === 'responsable'
          }))
        }

        if (!isEmpty(gestionnaireResponsable)) {
          for (let equipe of gestionnaire.equipes) {
            this.myData.gestionnaireEquipe = this.myData.gestionnaireEquipe === '-' ? equipe.libelle : this.myData.gestionnaireEquipe + ' / ' + equipe.libelle;
          }
        } else {
          if (!isEmpty(gestionnaire) && !isEmpty(gestionnaire.equipes[0])) {
            this.myData.gestionnaireEquipe = gestionnaire.equipes[0].libelle
          } else {
            this.myData.gestionnaireEquipe = "-"
          }
        }
      },
      getCollaborateurAffectant() {
        // console.log('this.gestionnaireAffecte',this.gestionnaireAffecte)
        if (this.gestionnaireAffecte.id !== undefined) {
          let dateAffectation = ''
          let gestionnaireAffectant = this.dossier.suivis.reduce((res,suivi) => {
            if ((/Affectation/.test(suivi.action) || /Réaffectation/.test(suivi.action)) && parseInt(suivi.commentaire) === parseInt(this.gestionnaireAffecte.id)) {
              dateAffectation = suivi.created_at
              if (parseInt(suivi.user_id,10) === 999999) {
                return {nom: 'Système', prenom: ''}
              } else {
                return suivi.gestionnaire
              }
            } else {
              return res
            }
          }, null);
          // console.log('dateAffectation',dateAffectation)
          if (gestionnaireAffectant) {
            this.dateTimeAffectation = formatDateTime(dateAffectation, '/');
            this.collaborateurAffectant = gestionnaireAffectant.prenom + ' ' + gestionnaireAffectant.nom;
          }
        }
      },
      getTreatmentStatus() {
        this.attachedStatus = [];
        let currentTraitement = this.traitements.reduce((res,traitement) => {
          return parseInt(traitement.id,10) === parseInt(this.$route.query.traitementId,10) ? traitement : res;
        },{});
        // console.log('currentTraitement',currentTraitement)
        let attachedStatus = []
        // On récupère les status pour le traitement sélectionné
        if(this.isTreatment('gestion_dbco') || this.isTreatment('validation_dbco')) {
          attachedStatus = _.filter(currentTraitement.status, (status) => status.libelle_technique === 'neutralise' || status.libelle_technique === 'traite_supprime');
        } else if(this.isTreatment('qualification_courrier') || this.isTreatment('ij_gestion_prestation') || this.isTreatment('gestion_inval') || this.isTreatment('gestion_dc') || this.isTreatment('ij_module_prevoyance')) {
          attachedStatus = _.filter(currentTraitement.status, (status) => {
            if (this.$parent.statusTraiteIds.indexOf(status.id) > -1 && status.libelle_technique !== 'traite_fusionne' && status.libelle_technique !== 'traite_integration_reussi_nsi' && status.libelle_technique !== 'traite_integration_refuse_nsi' && status.libelle_technique !== 'traite_auto_bpij' && status.libelle_technique !== 'neutralise_temporisation') {
              // On ne doit pas afficher les statuts de passage en module prev si dossier bpij ou client prest'IJ
              if (this.isTreatment('ij_gestion_prestation') && (status.libelle_technique === 'traite_passage_module_prevoyance' || status.libelle_technique === 'traite_passage_module_prevoyance_bon_integration')) {
                let isBpij =  false; //this.dossier.canal.libelle_technique === 'bpij';
                let isPrestij = false;
                // if (this.$parent.sirenPreference && this.$parent.sirenPreference.statut_prestij && (this.$parent.sirenPreference.statut_prestij.libelle_technique === 'actif_en_preparation' || this.$parent.sirenPreference.statut_prestij.libelle_technique === 'actif' || this.$parent.sirenPreference.statut_prestij.libelle_technique === 'deploye_dispense')) {
                //   isPrestij = true;
                // }
                if (!isPrestij && !isBpij) {
                  return status;
                }
              } else if (!this.isTreatment('ij_gestion_prestation') || (status.libelle_technique !== 'traite_passage_module_prevoyance' && status.libelle_technique !== 'traite_passage_module_prevoyance_bon_integration')) {
                return status;
              }
            }
            else if(this.isTreatment('ij_gestion_prestation') && this.dossier.canal.libelle_technique === 'bpij' && (status.libelle_technique && status.libelle_technique === 'neutralise_temporisation')){
              return status;
            }

          });
        } else {
          attachedStatus = _.filter(currentTraitement.status, (status) => this.$parent.statusEnAttente.id === status.id || this.$parent.statusTraiteIds.indexOf(status.id) > -1);
        }
        // On rempli les options du select
        this.attachedStatus.push({
          value: null,
          text: '------- Choisir un statut -------',
        });
        for (let status of attachedStatus) {
          this.attachedStatus.push({
            value: status.id,
            text: status.parent ? status.parent.libelle_bo + ' - ' + status.libelle_bo : status.libelle_bo,
          });
        }
        // On gère les statuts pour le traitement principal dans le cas des traitements experts
        this.mainTreatmentStatusOptions = [];
        let mainTreatmentStatus = [];
        if (this.$parent.dossierMainTreatment) {
          mainTreatmentStatus = _.filter(this.$parent.dossierMainTreatment.status, (status) => this.$parent.statusTraiteIds.indexOf(status.id) > -1 && status.libelle_technique !== 'traite_fusionne' && status.libelle_technique !== 'traite_dpc_sans_reponse' && status.libelle_technique !== 'traite_integration_reussi_nsi' && status.libelle_technique !== 'traite_integration_refuse_nsi');
        }

        for (let status of mainTreatmentStatus) {
          this.mainTreatmentStatusOptions.push({
            value: status.id,
            text: status.parent ? status.parent.libelle_bo + ' - ' + status.libelle_bo : status.libelle_bo,
          });
        }
      },
      manageChangeStatus() {
        let choosenStatus = this.$parent.currentTreatment.status.reduce((res,status) => status.id === parseInt(this.myData.statutActuel,10) ? status : res, null);
        
        this.showStatusMainTreatment = choosenStatus.libelle_technique === 'traite_finalise_nsi'

        if (choosenStatus.libelle_technique === 'neutralise_temporisation') {
          if (dossierHasOpenIncident(this.dossier, this.$parent.statusTraiteIds)) {
            this.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Vous ne pouvez pas passer ce dossier en temporisation BPIJ car il a encore des incidents ouverts.',
              showConfirmButton: false,
              timer: 5000
            })
            this.$set(this.myData, 'statutActuel', null);
            // this.myData.statutActuel = null
          }
        }
      },
      isTreatment(libelle_technique) {
        let treatment = _.find(this.traitements, (element) => element.libelle_technique === libelle_technique );
        return isEmpty(treatment) ? false : parseInt(this.$route.query.traitementId,10) === treatment.id
      },
      canAffecte(type) {
        let isResponsable = isResponsableEquipe();
        // console.log('this.$parent.allStatus',this.$parent.allStatus)
        let currentStatus = this.dossier.status.reduce((res, status) => parseInt(status.pivot.traitement_id,10) === parseInt(this.$route.query.traitementId) ? status : res,null);
        let canAutoAffecte = type === "autoAffecte" ? hasRule(rules.CAN_AUTO_AFFECTE) : false;

        // On rajoute une restriction pour ne pas pouvoir s'affecter ou affecter si on n'a pas le traitement nécessaire
        let hasTraitement = false;
        if (!isEmpty(this.$route.query.traitementId)) {
          let userTraitementIds = getUserTraitementIds();
          hasTraitement = userTraitementIds.indexOf(parseInt(this.$route.query.traitementId, 10)) > -1 || (!isEmpty(userTraitementIds) && this.dossier.type && this.dossier.type.libelle_technique === 'invja');
        }
        return (hasRule(rules.CAN_AFFECTE_DOSSIER) || hasRule(rules.CAN_AFFECTE_DOSSIER_ALL) || isResponsable || canAutoAffecte) && this.$route.query.traitementId && hasTraitement && currentStatus && this.$parent.statusTraiteIds.indexOf(currentStatus.id) === -1  && this.$parent.statusNeutraliseIds.indexOf(currentStatus.id) === -1;
      },
      launchAffectation(type) {
        if (type === 'affecte') {
          this.$refs['modal-affectation'].show()
        } else if (type === 'autoAffecte') {
          this.gestionnaireGestion = getUser().id;
          this.affecter();
        }
      },
      closeModalAffectation() {
        this.$refs['modal-affectation'].hide()
        this.clearError()
        this.gestionnaireGestion = ''
        this.gestionnairesGestion = []
      },
      affecter() {
        if (this.validateDataAffectationGestion()) {
          let currentTreatement = this.$parent.allTraitements.filter(traitement => {
            return (parseInt(traitement.id,10) === parseInt(this.$route.query.traitementId,10))
          })
          let textConfirm = "Voulez-vous affecter ce(s) dossier(s) avec le traitement " + currentTreatement[0].type + " : " + currentTreatement[0].libelle + " à ce gestionnaire ?"
          let dataPost = {
                  'dossierIds': this.dossier.id,
                  'gestionnaireId': this.gestionnaireGestion,
                  'traitementId': this.$route.query.traitementId,
                  'originalGestionnaireId': null,
                  'typeDossierId': [this.dossier.type_id],
                  'for': 'count',
                };

          let self = this;
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post('/espaceGestion/dossier/affectation', dataPost)
            .then((response) => {
              this.$store.commit('IS_LOADING', false);
              let texte = this.getTexteInfosAffectation(response, 'count', currentTreatement);
              let texteFinal = textConfirm + '<br>' + texte;
              this.$swal
                .fire({
                  title: "Êtes-vous sûr?",
                  html: texteFinal,
                  type: "warning",
                  reverseButtons: true,
                  showCancelButton: true,
                  allowOutsideClick: false,
                  cancelButtonColor: "#ff1744",
                  confirmButtonText: "Confirmer",
                  cancelButtonText: "Annuler"
                })
                .then(result => {
                  if (result.value) {
                    let dataPost = {
                      'dossierIds': this.dossier.id,
                      'gestionnaireId': this.gestionnaireGestion,
                      'traitementId': this.$route.query.traitementId,
                      'typeDossierId': [this.dossier.type_id],
                      'originalGestionnaireId': null,
                    };
                    // console.log('this.$parent.traitementId',this.$parent.traitementId)
                    this.$store.commit('IS_LOADING', true);
                    this.$axios
                      .post('/espaceGestion/dossier/affectation', dataPost)
                      .then((response) => {
                        // console.log(response)
                        this.$store.commit('IS_LOADING', false);
                        this.$event.emit('refreshDossier');
                        this.gestionnaireGestion = '';
                        this.gestionnairesGestion = [];
                        this.$refs['modal-affectation'].hide();
                        // console.log('response.data',response.data)
                        let texte = this.getTexteInfosAffectation(response, 'affectation', currentTreatement);
                        self.$swal({
                          position: 'top',
                          type: 'success',
                          title: 'Confirmation',
                          html: texte,
                          width: '42rem',
                          showConfirmButton: false,
                          timer: 0
                        });
                      })
                      .catch(function (error) {
                        console.log(error)
                        self.$store.commit('IS_LOADING', false);
                        let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                        if (error.response && error.response.status === 424) {
                          textError = error.response.data.message;
                        }
                        self.$swal({
                          position: 'top',
                          type: 'error',
                          title: 'Attention !!',
                          text: textError,
                          showConfirmButton: false,
                          timer: 6000
                        });
                      });
                  }
                });
            })
            .catch(function (error) {
                console.log(error)
                self.$store.commit('IS_LOADING', false);
                let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                if (error.response && error.response.status === 424) {
                  textError = error.response.data.message;
                }
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: textError,
                  showConfirmButton: false,
                  timer: 4000
                });
              });
        }
      },
      getTexteInfosAffectation(response, context, currentTreatement) {
        let texte = context === 'count' ? '<div class="text-left">L\'affectation comprendra ' + response.data.message + ' dossiers' : '<div class="text-left">Affectation de ' + response.data.message + ' dossier(s) réalisée avec succès';
        let typeDossier = 'typeDossier';
        let texteArray = [];
        // console.log('currentTreatement',currentTreatement,currentTreatement.libelle_technique !== 'gestion_dbco')
        // On n'affiche pas d'info sup pour DBCO (sans ça les dossiers affectés sont comptabilisés en tant que prolong)
        if (isEmpty(currentTreatement[0]) || (!isEmpty(currentTreatement[0]) && currentTreatement[0].libelle_technique !== 'gestion_dbco' && currentTreatement[0].libelle_technique !== 'validation_dbco')) {

          if (response.data.nbDossierOuverture > 0) {
            typeDossier = ` ${response.data.nbDossierOuverture} dossier(s) ouverture`;
            texteArray.push(typeDossier)
          }
          if (response.data.nbDossierProlongation > 0) {
            typeDossier = ` ${response.data.nbDossierProlongation} dossier(s) prolongation`;
            texteArray.push(typeDossier)
          }
          if (response.data.nbDossierBpij > 0) {
            typeDossier = ` dont ${response.data.nbDossierBpij} dossier(s) BPIJ`;
            texteArray.push(typeDossier)
          }
          texteArray = texteArray.join(',')
        }
        // console.log('texteArray' + texteArray);
        if (!isEmpty(texteArray)) {
          texte = `${texte} (${texteArray})` + '.<br>';
        } else {
          texte = `${texte}` + '.<br>';
        }
        if (response.data.rejected) {
          let precision = context === 'count' ? 'ne pourront être affectés'  : 'n\'ont pas été affectés';
          texte = texte  + response.data.rejected + ` dossiers ` + precision + ` pour une des raisons suivantes :<br>
            <ul><li>Soit le gestionnaire destinataire n\'a pas le traitement nécessaire pour gérer ces dossiers.</li>
            <li>Soit vous avez choisi de n'affecter que des dossiers sans ouvertures et ceux-ci en contenaient</li></ul></div>`;
        } else {
          texte = texte + '</div>';
        }

        return texte;
      },
      desaffectation() {
        let self = this;
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous désaffecter ce dossier ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Confirmer",
            cancelButtonText: "Annuler"
          })
          .then(result => {
            if (result.value) {
              let dataPost = {
                'dossierIds': this.dossier.id,
                'traitementId': this.$route.query.traitementId,
                'originalGestionnaireId': null,
              };
              // console.log('this.$route.query.traitementId',this.$route.query.traitementId)
              this.$store.commit('IS_LOADING', true);
              this.$axios
                .post('/espaceGestion/dossier/desaffecter', dataPost)
                .then((response) => {
                  // console.log(response)
                  this.$store.commit('IS_LOADING', false);
                  this.$event.emit('refreshDossier');
                  this.gestionnaireGestion = '';
                  this.gestionnairesGestion = [];
                  // console.log('response.data',response.data)
                  let html = '<div class="text-left">Désaffectation de ' + response.data.message + ' dossiers réalisée avec succès.<br>';
                  if (response.data.rejected) {
                    html = html + response.data.rejected + ' dossiers n\'ont pas été désaffectés car leurs statuts ou celui des dossiers du même salarié ne le permet pas.<br>Voici la liste des dossiers non désaffectés : ';
                    for (let dossierId of response.data.dossierRejectedIds) {
                      if (response.data.dossierRejectedIds.indexOf(dossierId) === (response.data.dossierRejectedIds.length - 1)) {
                        html = html + dossierId;
                      } else {
                        html = html + dossierId + ', ';
                      }
                    }
                    html = html + '</div>';
                  }
                  self.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Confirmation',
                    html: html,
                    showConfirmButton: false,
                    timer: 0
                  });
                })
                .catch(function (error) {
                  let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                  if (error.response.status === 400) {
                    textError = 'Vous devez choisir au moins un dossier';
                  }
                  if (error.response.status === 424) {
                    textError = error.response.data.message;
                  }
                  self.$store.commit('IS_LOADING', false);
                  self.$swal({
                    position: 'top',
                    type: 'error',
                    title: 'Attention !!',
                    text: textError,
                    showConfirmButton: false,
                    timer: 4000
                  });
                });
            }
          });
      },
      async onSearchGestionnaireGestion(search) {
        let self = this
        const lettersLimit = 1

        this.noData = false
        if (search.length < lettersLimit) {
          this.gestionnairesGestion = []
          this.loadingGestionnaire = false
          return
        }
        this.loadingGestionnaire = true

        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(async () => {
          this.$axios
            .get('/espaceGestion/gestionnaire/autocompleteRecherche?query=' + search + '&type=equipe')
            .then(response => {
              // console.log(response)
              this.loadingGestionnaire = false
              this.gestionnairesGestion = response.data
              if (!this.gestionnairesGestion.length) this.noData = true
            })
            .catch(function (error) {
              console.log(error)
              self.loadingGestionnaire = false
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              })
            })
        }, 500)
      },
      validateDataAffectationGestion() {
        let error = false
        this.clearError()

        if (this.gestionnaireGestion === '' || this.gestionnaireGestion === null) {
          error = true
          this.errors.gestionnaire = 'Vous devez séléctionner un gestionnaire'
        }
        // console.log(this.gestionnaireGestion)
        return !error
      },
      hasManageDossier() {
        let self = this;
        const dataPost = {
          dossiers_ids: this.dossier.id,
          gestionnaire_id: this.gestionnaireGestion,
        }
        this.$axios.post('/espaceGestion/gestionnaire/hasOagOapHabilitation', dataPost)
          .then(response => {
            if (response.data.errors.length > 0) {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                html: `<ul>${response.data.errors.map(message => `<li>${message}</li>`)}</ul>`,
                showConfirmButton: false,
                timer: 4500
              });
            } else {
              if (this.isTreatment('ij_module_prevoyance')) {
                this.$axios.post('/espaceGestion/gestionnaire/hasNsiUserActeur', dataPost)
                  .then(response => {
                    if (response.data.errors.length > 0) {
                      this.$swal({
                        position: "top",
                        type: "error",
                        title: "Attention !!",
                        html: `<ul>${response.data.errors.map(message => `<li>${message}</li>`)}</ul>`,
                        showConfirmButton: false,
                        timer: 4500
                      });
                    } else {
                      this.affecter();
                    }
                  })
                  .catch(function (error) {
                    console.log(error)
                    self.$swal({
                      position: 'top',
                      type: 'error',
                      title: 'Attention !!',
                      text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                      showConfirmButton: false,
                      timer: 4000
                    });
                  });
              } else {
                this.affecter();
              }
            }
            // else {
            //   this.affecter();
            // }
          })
          .catch(function (error) {
            console.log(error)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 4000
            });
          });
      },
      clearError() {
        this.errors.gestionnaire = '';
      },
      getTraitementControle(){
        this.traitementControleId = this.getTraitementIdByLibelleTehnique('ij_qualite_prestation');
      },
      getTraitementIdByLibelleTehnique(libelle_technique) {
        let treatment = _.find(this.traitements, function (element) {
          return element.libelle_technique === libelle_technique;
        });
        return treatment && treatment.id;
      },
      isTempo() {
        let currentStatus = this.dossier.status.reduce((res, status) => parseInt(status.pivot.traitement_id,10) === parseInt(this.$route.query.traitementId) ? status : res,null);
        return !isEmpty(currentStatus) ? currentStatus.libelle_technique === 'en_attente_tempo' : false;
      },
      retourATraiter() {
        let self = this;
        let dataPost = {
          dossierId: this.dossier.id,
          traitementId: this.$route.query.traitementId
        }
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .post("/espaceGestion/dossier/get-back-tempo",dataPost)
          .then(async response => {
            await this.$parent.save('save');
            this.$store.commit('IS_LOADING', false);
            this.$event.emit('refreshDossier');
          })
          .catch(function(error){
            console.log(error)
            self.$store.commit('IS_LOADING', false);
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
          });
      },
    }
  }
</script>
